import { Form, Spin } from "antd";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Endpoints from "../../api/endpoints";
import useSuccessErrorModal from "../../hooks/successErrorModal/useSuccessErrorModal";
import PageRoutes from "../../utils/routes";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import EndpointFunctions from "../../utils/Functions/endpointFunctions";
import ApplicationForm from "./ApplicationForm";
import routes from "../../utils/routes";

const CreateApplication = () => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const axiosPrivate = useAxiosPrivate();

  const navigate = useNavigate();
  const { showModal, closeModal, ModalComponent } = useSuccessErrorModal();

  const createApplication = async (values) => {
    console.log("---VALUES---", values);
    setIsLoading(true);

    const requestBody = {
      app: values.app,
      iosLink: values.iosLink,
      androidLink: values.androidLink,
    };
    console.log("---REQUEST BODY---", requestBody);

    const result = await EndpointFunctions.postData({
      endpointURL: Endpoints.addApplication,
      axiosPrivate: axiosPrivate,
      requestBody: requestBody,
    });

    if (result.success) {
      setIsLoading(false);
      showModal("Başarılı", "Uygulama Oluşturuldu.", () => {
        closeModal();
        navigate(routes.applications);
      });
    } else {
      setIsLoading(false);
      showModal(result.errorTitle, result.errorMessage, () => {
        closeModal();
      });
    }
  };

  return (
    <div>
      <ApplicationForm form={form} onFinish={createApplication} />

      <Spin spinning={isLoading} fullscreen />

      <ModalComponent></ModalComponent>
    </div>
  );
};

export default CreateApplication;
